import React, { FC, HTMLAttributes, CSSProperties } from "react";

interface IEllipsisTextProps extends HTMLAttributes<HTMLSpanElement> {
  text: string;
  length: number;
  tail?: string;
  tailClassName?: string;
}

const EllipsisText: FC<IEllipsisTextProps> = ({
  text,
  length,
  tail = "...",
  tailClassName = "more",
  ...others
}) => {
  // If text is shorter than limit or invalid length, show full text
  if (text.length <= length || length < 0) {
    return <span {...others}>{text}</span>;
  }

  // Calculate display text
  let displayText: string;
  if (length - tail.length <= 0) {
    displayText = "";
  } else {
    displayText = text.slice(0, length - tail.length);
  }

  const tailStyle: CSSProperties = {
    cursor: "auto",
  };

  const spanStyle: CSSProperties = {
    MozUserSelect: "text",
    WebkitUserSelect: "text",
    msUserSelect: "text",
    userSelect: "text",
    ...others.style,
  };

  return (
    <span title={text} {...others} style={spanStyle}>
      {displayText}
      <span style={tailStyle} className={tailClassName}>
        {tail}
      </span>
    </span>
  );
};

interface ITooltipProps {
  text: string | null | undefined;
  length?: number;
}

const Tooltip: FC<ITooltipProps> = ({ text, length = 13 }) => {
  if (!text) {
    return null;
  }

  const cleanText = text.replace(/<[^>]*>/g, "");

  return (
    <div>
      <EllipsisText text={cleanText} length={length} />
    </div>
  );
};

export default Tooltip;
